"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var attach_script_1 = tslib_1.__importDefault(require("../../../common/utils/attach-script"));
var url_1 = tslib_1.__importDefault(require("../../../common/utils/url"));
var styles_scss_1 = tslib_1.__importDefault(require("./styles.scss"));
var scriptApiUrl = 'https://player.vimeo.com/api/player.js';
var DEFAULT_VOLUME = 1;
var scriptPromise = null;
var VimeoExternal = /** @class */ (function (_super) {
    tslib_1.__extends(VimeoExternal, _super);
    function VimeoExternal(props) {
        var _this = _super.call(this, props) || this;
        _this.onReady = function (VimeoPlayer) {
            if (VimeoPlayer === void 0) { VimeoPlayer = window.Vimeo.Player; }
            _this.player = new VimeoPlayer(_this.iframeRef.current);
            _this.attachEventsToPlayer();
            _this.setSettings(_this.props);
        };
        _this.player = null;
        _this.iframeRef = react_1.default.createRef();
        _this.muted = props.muted;
        _this.__volume = 0;
        return _this;
    }
    VimeoExternal.prototype.componentDidMount = function () {
        // load once
        scriptPromise = scriptPromise || (0, attach_script_1.default)(scriptApiUrl, true);
        var ref = this.iframeRef.current;
        if (!ref) {
            this.player = null;
            return;
        }
        // TODO: replace with setting 'allow' attribute in jsx after migration to React 16
        ref.setAttribute('allow', 'autoplay');
        // if src is set before allow="autoplay", 'allow' has no effect
        ref.setAttribute('src', this.getIframeSrcUrl());
        this.props.onIframeRef(ref);
        scriptPromise.then(this.onReady);
    };
    VimeoExternal.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.src === this.props.src) {
            this.setSettings(nextProps, this.props);
        }
    };
    VimeoExternal.prototype.componentWillUnmount = function () {
        if (this.player) {
            this.detachEventsFromPlayer();
        }
    };
    VimeoExternal.prototype.attachEventsToPlayer = function () {
        var _a = this.props, onPlay = _a.onPlay, onPause = _a.onPause, onEnd = _a.onEnd, onVolumeChange = _a.onVolumeChange;
        this.player.on('play', onPlay);
        this.player.on('pause', onPause);
        this.player.on('ended', onEnd);
        this.player.on('volumechange', onVolumeChange);
    };
    VimeoExternal.prototype.detachEventsFromPlayer = function () {
        var _a = this.props, onPlay = _a.onPlay, onPause = _a.onPause, onEnd = _a.onEnd, onVolumeChange = _a.onVolumeChange;
        this.player.off('play', onPlay);
        this.player.off('pause', onPause);
        this.player.off('ended', onEnd);
        this.player.on('volumechange', onVolumeChange);
    };
    VimeoExternal.prototype.setSettings = function (_a, prevProps) {
        var _this = this;
        var isVideoPlayRequested = _a.isVideoPlayRequested, isVideoPauseRequested = _a.isVideoPauseRequested, loop = _a.loop, muted = _a.muted;
        if (prevProps === void 0) { prevProps = {}; }
        if (!this.player) {
            return null;
        }
        this.toggleMute(muted).then(function () {
            if (prevProps.isVideoPlayRequested !== isVideoPlayRequested &&
                isVideoPlayRequested) {
                _this.togglePaused(false);
            }
            if (prevProps.isVideoPauseRequested !== isVideoPauseRequested &&
                isVideoPauseRequested) {
                _this.togglePaused(true);
            }
        });
        this.toggleLoop(loop);
    };
    VimeoExternal.prototype.togglePaused = function (paused) {
        var _this = this;
        this.player.getPaused().then(function (currentPaused) {
            if (paused && !currentPaused) {
                _this.player.pause();
            }
            if (!paused && currentPaused) {
                _this.player.play();
            }
        });
    };
    VimeoExternal.prototype.toggleLoop = function (loop) {
        if (loop) {
            this.player.setLoop(true);
        }
        else {
            this.player.setLoop(false);
        }
    };
    VimeoExternal.prototype.toggleMute = function (muted) {
        var _this = this;
        return this.player.getVolume().then(function (volume) {
            if (muted === _this.muted) {
                return Promise.resolve();
            }
            _this.muted = muted;
            if (muted) {
                _this.__volume = volume;
                return _this.player.setVolume(0);
            }
            return _this.player.setVolume(_this.__volume || DEFAULT_VOLUME);
        });
    };
    VimeoExternal.prototype.getIframeSrcUrl = function () {
        var _a = this.props, src = _a.src, simple = _a.simple, mobileMode = _a.mobileMode;
        var query = {
            muted: this.muted ? '1' : '0',
        };
        if (simple || mobileMode) {
            query.badge = '0';
            query.portrait = '0';
            query.title = '0';
        }
        var url = new url_1.default(src);
        // https is required for autoplay
        url.protocol = 'https';
        url.search = query;
        return url.toString();
    };
    VimeoExternal.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, width = _b.width, height = _b.height, isVideoPauseRequested = _b.isVideoPauseRequested, isVideoPlayRequested = _b.isVideoPlayRequested, isVideoPlaying = _b.isVideoPlaying, isVideoPaused = _b.isVideoPaused, fillAllSpace = _b.fillAllSpace;
        var tabIndex = isVideoPauseRequested ||
            isVideoPlayRequested ||
            isVideoPlaying ||
            isVideoPaused
            ? 0
            : -1;
        return (react_1.default.createElement("iframe", { title: "Vimeo", width: width, height: height, frameBorder: "0", allowFullScreen: true, tabIndex: tabIndex, ref: this.iframeRef, className: (0, classnames_1.default)(styles_scss_1.default.iframe, className, (_a = {},
                _a[styles_scss_1.default.fillAllSpace] = fillAllSpace,
                _a)) }));
    };
    VimeoExternal.propTypes = {
        src: prop_types_1.default.string.isRequired,
        onPlay: prop_types_1.default.func,
        onPause: prop_types_1.default.func,
        onEnd: prop_types_1.default.func,
        onVolumeChange: prop_types_1.default.func,
        onIframeRef: prop_types_1.default.func.isRequired,
        width: prop_types_1.default.number,
        height: prop_types_1.default.number,
        className: prop_types_1.default.string,
        simple: prop_types_1.default.bool,
        mobileMode: prop_types_1.default.bool,
        isVideoPlayRequested: prop_types_1.default.bool,
        isVideoPauseRequested: prop_types_1.default.bool,
        isVideoPlaying: prop_types_1.default.bool,
        isVideoPaused: prop_types_1.default.bool,
        fillAllSpace: prop_types_1.default.bool,
        loop: prop_types_1.default.bool,
        muted: prop_types_1.default.bool,
    };
    return VimeoExternal;
}(react_1.default.Component));
exports.default = VimeoExternal;
//# sourceMappingURL=vimeo.js.map